import { Component, ContentChildren, inject, QueryList } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavItem } from './nav-item';


@Component({
    selector: 'ui-tabs',
    host: {
        '[attr.role]': '"navigation"',
    },
    styles: [
        `
        .nav {
            display: flex;
            flex-wrap: wrap;
            padding-left: 0;
            margin-top: 0;
            margin-bottom: -1px;
            list-style: none;
        }
        .nav-tabs {
            border-bottom: 1px #d8e7f0 solid;
        }
        `,
    ],
    template: `
        <ul class="nav nav-tabs nav-desktop d-none d-sm-flex">
            <ng-content></ng-content>
        </ul>
        <div class="form-group nav-mobile d-block d-sm-none mt-3 mb-1">
            <select class="form-control arrow-select font-weight-bold" #target (change)="navigate(target.value)">
                @for (item of items; track item.link) {
                    <option
                        [value]="item.link"
                        [textContent]="item.content.nativeElement.textContent"
                        [attr.selected]="isSelected(item.link) ? 'selected' : null">
                    </option>
                }
            </select>
        </div>
    `,
})
export class TabsComponent {

    @ContentChildren(NavItem) items: QueryList<NavItem>;

    private router = inject(Router);

    private route = inject(ActivatedRoute);

    navigate(link: string) {
        this.router.navigate([link], { relativeTo: this.route, queryParamsHandling: 'preserve' });
    }

    isSelected(link: string) {
        const url = this.router.createUrlTree([link], { relativeTo: this.route });
        return this.router.isActive(url, { paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' });
    }
}
